import {GetUnitsUrl, GetUnitsUrlModel} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetUnitsUrl implements GetUnitsUrl {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetUnitsUrlModel>,
	) {}

	async get(): Promise<GetUnitsUrlModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
